module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_logistics-191e49ee5db53761d9db3e1b3084a1af.png";